import React from 'react';
import { getMetadataRows } from '../../constants/metadataFieldDescriptors';
import type { VoyagerDetailItem } from '../../models/detail-item';

interface DetailsTabProps {
  item: VoyagerDetailItem;
}

const DetailsTab: React.FC<DetailsTabProps> = ({ item }) => {
  const rows = getMetadataRows(item);

  return (
    <div className="details-table-container">
      <table className="details-table">
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td className="field-label">{row.label}</td>
              <td className="field-value">
                {row.isLink ? (
                  <a
                    href={String(row.value)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {String(row.value)}
                  </a>
                ) : (
                  String(row.value)
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DetailsTab;
